let FORMAT_NAME = 'zx-soundtracker';

export { FORMAT_NAME };
